export default {
	comments: {
		confirm_delete_comment: 'Do you really want to delete this comment?',
		// Shared "Comments / Emails" section (reports + craftsman tasks)
		composer: {
			modeComment: '@:common.comment',
			modeMail: 'Email',
			open: 'Write comment or email',
			to: 'To',
			cc: 'CC',
			bcc: 'BCC',
			subject: '@:common.subject',
			body: 'Message',
			template: 'Template',
			templateHint:
				'Select a template to prefill subject and body. Both fields remain freely editable afterwards.',
			noEmail: 'No email address on file',
			freeEmailHint: 'Enter another email address and confirm with Enter',
			invalidEmail: '"{value}" is not a valid email address.',
			recipientRequired:
				'Please select at least one recipient in the "To" field.',
			subjectRequired: 'Please enter a subject.',
			bodyRequired: 'Please enter a message.',
			missingPlaceholders:
				'No values are available for the following fields: {fields}',
			confirmOverwriteTemplate:
				'Changing the template will discard your edits to subject and body. Do you want to continue?',
			previewFailed: 'The preview could not be loaded.',
			sendFailed: 'The email could not be sent.',
			publicLabel: 'public',
			internalLabel: 'internal',
			emailConflict: 'Internal marking is not possible when sending an email',
			markAsInternal: 'Mark comment as internal',
			internalInfo: 'The comment will only be visible to the property management',
			attachments: {
				title: 'Attachments',
				none: 'No attachments',
				show: 'Add attachments',
				hide: 'Hide attachments',
				upload: 'Select files',
				existing: 'Attach linked documents',
				noDocuments: 'No linked documents available.',
				totalSize: 'Attachments total: {size}',
			},
		},
	},
}
